import { useEffect } from 'react';
import { useQuery } from '@apollo/client';

import { GET_CONFIGURATION } from '../../../graphql/configuration/queries/get-configuration';
import { IConfigurationSettingsProps } from './configuration-settings.models';
import {
  setCaptcha,
  setC2CMode,
  setIsVideoCall,
  setMyopiaControl,
  setMms,
  setAllowedStoreGroupCodes,
  setYandexMapStyleUpdatedAt,
  setIsPhoneCallConsent,
  setIsRuStore,
  setIsLiveChat,
} from '../../../graphql/configuration/configuration.cache';
import {
  getCaptcha,
  getC2CMode,
  getVideoCallEnabled,
  getMyopiaControlEnabled,
  getMmsEnabled,
  getAllowedGroupCodes,
  getYandexMapStyle,
  getRuStoreEnabled,
  getLiveChatEnabled,
} from './utils';
import { setOrderModalToStorage } from '../../../utils/order/set-orders-status-to-storage';
import { getPhoneCall } from './utils/get-phone-call-consent';

export const ConfigurationSettings = ({ children }: IConfigurationSettingsProps): JSX.Element => {
  const { data } = useQuery(GET_CONFIGURATION, {
    context: { clientName: 'anonymous' },
  });

  useEffect(() => {
    if (data?.configuration?.length) {
      const { isEnabled, type, isVisibleCaptcha } = getCaptcha(data.configuration);
      setCaptcha({ isEnabled, type, isVisibleCaptcha });
      setC2CMode(getC2CMode(data.configuration));
      setOrderModalToStorage(getC2CMode(data.configuration));
      setIsVideoCall(getVideoCallEnabled(data.configuration));
      setMyopiaControl(getMyopiaControlEnabled(data.configuration));
      setMms(getMmsEnabled(data.configuration));
      setAllowedStoreGroupCodes(getAllowedGroupCodes(data.configuration));
      setYandexMapStyleUpdatedAt(getYandexMapStyle(data.configuration));
      setIsPhoneCallConsent(getPhoneCall(data.configuration));
      setIsRuStore(getRuStoreEnabled(data.configuration));
      setIsLiveChat(getLiveChatEnabled(data.configuration));
    }
  }, [data]);

  return children as JSX.Element;
};
